<template>
	<v-form ref="form" @submit.prevent="validate">
		<template v-if="isCustomLogin">
			<v-select
				:loading="dc4.loadingUsers"
				v-model="dc4.form.dc4usuario"
				:items="dc4.users"
				prepend-icon="mdi-account"
				label="Usuário"
				required
				color="secondary"
				:rules="userRules"
				no-data-text="Nenhum usuário cadastrado"
				id="user"
				item-value="dc4usuario"
				item-text="dc4nome"
				item-color="secondary"
				:disabled="loggedUser">
			</v-select>
			<v-text-field
				id="password"
				label="Senha"
				prepend-icon="mdi-lock"
				type="password"
				v-model="dc4.form.dc4senha2"
				required
				color="secondary"
				:rules="passwordRules"></v-text-field>
			<v-select
				v-if="!validateOnly"
				:loading="dc4.loadingTerminals"
				v-model="dc4.form.pd0codigo"
				:items="dc4.terminals"
				prepend-icon="mdi-cash-register"
				label="Caixa"
				required
				color="secondary"
				:rules="terminalRules"
				no-data-text="Nenhum terminal cadastrado"
				id="terminal"
				item-value="pd0codigo"
				item-color="secondary">
				<template v-slot:selection="{ item }"> {{ item.pd0codigo }} - {{ item.pd0nome }} </template>
				<template v-slot:item="{ item }"> {{ item.pd0codigo }} - {{ item.pd0nome }} </template>
			</v-select>
		</template>
		<template v-else>
			<template v-if="!isSelectingCompany || dc4.lstConfiguredCompanies.length === 1">
				<v-select
					:loading="dc4.loadingUsers"
					v-model="dc4.form.dc4usuario"
					:items="dc4.users"
					prepend-icon="mdi-account"
					label="Usuário"
					required
					color="secondary"
					:rules="userRules"
					no-data-text="Nenhum usuário cadastrado"
					id="user"
					item-value="dc4usuario"
					item-text="dc4nome"
					item-color="secondary">
				</v-select>
				
				<v-text-field
					id="password"
					label="Senha"
					prepend-icon="mdi-lock"
					type="password"
					v-model="dc4.form.dc4senha2"
					required
					color="secondary"
					:loading="dc4.loadingCompanies"
					:rules="passwordRules">
				</v-text-field>

				<v-select
					v-if="!validateOnly && dc4.lstConfiguredCompanies.length === 1"
					:loading="dc4.loadingTerminals"
					v-model="dc4.form.pd0codigo"
					:items="dc4.terminals"
					prepend-icon="mdi-cash-register"
					label="Caixa"
					required
					color="secondary"
					:rules="terminalRules"
					no-data-text="Nenhum terminal cadastrado"
					id="terminal"
					item-value="pd0codigo"
					item-color="secondary">
					<template v-slot:selection="{ item }"> {{ item.pd0codigo }} - {{ item.pd0nome }} </template>
					<template v-slot:item="{ item }"> {{ item.pd0codigo }} - {{ item.pd0nome }} </template>
				</v-select>

				<div class="text-right text-body-2 pt-3" v-if="!validateOnly">
					<router-link :to="{ name: 'changePassword' }" class="secondary--text"> Trocar senha &gt; </router-link>
				</div>
			</template>
			<template v-else>
				<v-select
					v-if="!validateOnly"
					:loading="dc4.loadingCompanies"
					:value="dc4.selectedCompany"
					item-value="companyCode"
					:items="dc4.companies"
					@change="selectCompany"
					prepend-icon="mdi-domain"
					label="Empresa"
					return-object
					required
					color="secondary"
					:rules="companyRules"
					no-data-text="Nenhuma empresa cadastrada"
					id="company"
					item-color="secondary">
					<template v-slot:selection="{ item }"> {{ item.companyCode }} - {{ item.companyName }} </template>
					<template v-slot:item="{ item }"> {{ item.companyCode }} - {{ item.companyName }} </template>
				</v-select>
				<v-select
					v-if="!validateOnly"
					:loading="dc4.loadingTerminals"
					v-model="dc4.form.pd0codigo"
					:items="dc4.terminals"
					prepend-icon="mdi-cash-register"
					label="Caixa"
					required
					color="secondary"
					:rules="terminalRules"
					no-data-text="Nenhum terminal cadastrado"
					id="terminal"
					item-value="pd0codigo"
					item-color="secondary">
					<template v-slot:selection="{ item }"> {{ item.pd0codigo }} - {{ item.pd0nome }} </template>
					<template v-slot:item="{ item }"> {{ item.pd0codigo }} - {{ item.pd0nome }} </template>
				</v-select>

				<div class="text-right text-body-2 pt-3" v-if="!validateOnly">
					<div> 
						Bem vindo {{ dc4.form.dc4usuario }}. 
					</div>
					<a @click="changeUser" class="secondary--text pr-1 text-decoration-underline"> Trocar usuário </a>
				</div>
			</template>
		</template>
		<slot></slot>
		<div class="text-center text-body-2 red--text pt-3">
			<div v-if="dc4.form.error">
				{{ dc4.form.error }}
			</div>
			<div v-else-if="shouldDisplayWarningBlockMessage">
				<div v-if="shouldDisplayTriesLeft">
					Você possui mais {{ maximumTries - dc4.dc4tentativas }} tentativas antes do seu acesso ser bloqueado.
				</div>
			</div>
		</div>
		<div class="text-center pt-4">
			<v-btn
				:loading="dc4.form.loading"
				color="secondary"
				large
				type="submit"
				text
				rounded
			>
				{{ textButtom }}
			</v-btn>
		</div>

	</v-form>
</template>

<script>
	import { mapGetters } from "vuex"

	export default {
		props: {
			validateOnly: {
				default: false,
				type: Boolean,
			},
			isCustomLogin: {
				default: false,
				type: Boolean,
			},
			storeAction: {
				type: String,
				default: "dc4/auth",
			},
			textButtom: {
				type: String,
				default: "Entrar",
			},
			params: {
				type: Object,
				default: null,
			},
			loggedUser: {
				default: false,
				type: Boolean,
			},
			selectedUser: {
				default: "SPV",
				type: String,
			},
		},
		data() {
			return {
				userRules: [v => !!v || "Usuário é obrigatório"],
				terminalRules: [v => !!v || "Terminal é obrigatório"],
				passwordRules: [v => !!v || "A senha é obrigatória"],
				isSelectingCompany: false,
				maximumTries: null,
				isActivated: false,
				selectedUserLogin: null,
			}
		},
		computed: {
			...mapGetters({
				dc4troca: "dc4/getDc4troca",
			}),
			dc4: {
				get() {
					return this.$store.state.dc4
				},
			},
			changePassword() {
				return this.$store.state.dc4.changePassword
			},
			companyRules(){
				return [v => !!v && this.isSelectingCompany || "A empresa é obrigatória"]
			},
			canValidateLxlTenta() {
				return this.isActivated
			},
			shouldDisplayWarningBlockMessage() {
				return this.canValidateLxlTenta && !this.isSelectingCompany && this.dc4.form.dc4usuario
			},
			isUserBlocked() {
				return this.canValidateLxlTenta && this.selectedUserLogin?.dc4bloq
			},
			shouldDisplayTriesLeft() {
				return this.maximumTries - this.dc4.dc4tentativas <= 3 && !this.isUserBlocked
			},
		},
		methods: {
			changeUser(){
				this.$store.dispatch("dc4/initForm")
				this.isSelectingCompany = false
				this.dc4.selectedCompany = null
			},
			async validate() {
				if(this.isSelectingCompany || this.isCustomLogin || this.dc4.lstConfiguredCompanies.length == 1){
					await this.validateDefaultLogin()
					return;
				}
				this.selectedUserLogin = await this.$store.dispatch("dc4/getUserData", this.dc4.form.dc4usuario)
				if (this.$refs.form.validate()) {
					const payload = await this.$store.dispatch("dc4/validateUserLogin")
					await this.$store.dispatch("lxl/getUserBlockInfo", true).then(({ maximumTries, isActivated }) => {
						this.maximumTries = maximumTries
						this.isActivated = isActivated
					})

					if (!payload) return

					this.isSelectingCompany = true
					this.dc4.form.error = null

					await this.$store.dispatch("dc4/findAllConnectionsByUser", this.dc4.form.dc4usuario)
					if (this.dc4.companies.length && !this.dc4.selectedCompany) {
						await this.selectCompany(this.dc4.companies[0])
						return;
					}
				}
				return
			},
			async validateDefaultLogin() {
				if (!this.$refs.form.validate()) {
					return
				}

				const payload = await this.$store.dispatch(this.storeAction, this.params)
				if (!payload) {
					return
				}

				if (payload.isLogged) {
					this.dc4.form.error = `Usuário já está logado em outro navegador`
					return
				}

				this.$emit("auth")

				const lxdPayload = await this.$store.dispatch("lxd/find")
				if (lxdPayload) {
					await this.$store.dispatch("cx0/verifyCashier", true)
				}
				await this.$store.dispatch("lxe/find")
				await this.$store.dispatch("lxf/search", {})
				await this.$store.dispatch("fv2/find")
				await this.$store.dispatch("lxl/find")
				await this.$store.dispatch("att/find")

				this.dc4.form.dc4senha2 = null
				this.isSelectingCompany = false
				this.dc4.selectedCompany = null
			},
			selectCompany(company){
				this.dc4.selectedCompany = company

				this.dc4.terminals = []
				this.dc4.form.pd0codigo = null

				this.$refs.form?.reset()

				if(company && company.companyCode && company.companyCode != "") 
					this.$store.dispatch("dc4/findAllTerminals")
			},
			changeSelectedUser() {
				if(this.loggedUser) {
					this.$nextTick(() => {
						this.$set(this.dc4.form,"dc4usuario",this.selectedUser)
					})
				}
			},
		},

		watch: {
			"dc4.form.dc4usuario"(newUser, oldUser) {
				if (newUser && newUser !== oldUser) {
					this.dc4.form.error = null
					this.$store.dispatch("lxl/getUserBlockInfo", true).then(({ maximumTries, isActivated }) => {
						this.maximumTries = maximumTries
						this.isActivated = isActivated
					})
				}
			},
			selectedUser: 'changeSelectedUser'
		},
		async mounted() {
			await this.$store.dispatch("dc4/findAllUsers", this.$route.name === "login")
			const { maximumTries, isActivated, expirablePass } = await this.$store.dispatch("lxl/getUserBlockInfo", true)
			this.maximumTries = maximumTries
			this.isActivated = isActivated
			this.dc4.lxlexppass = expirablePass

			if (this.$route.name === "login") {
				await this.$store.dispatch("dc4/findAllConfiguredCompanies")
				if (this.dc4.lstConfiguredCompanies.length === 1) {
					await this.selectCompany(this.dc4.lstConfiguredCompanies[0])
					return;
				}
			}

			const jsonCompany = localStorage.getItem("companyCode")
			if(jsonCompany){
				this.selectCompany(this.dc4.companies.find(company => company.companyCode == jsonCompany))
				let jsonPd0 = localStorage.getItem("terminal")
				if (jsonPd0) {
					let pd0 = JSON.parse(jsonPd0)
					if (pd0.pd0codigo) {
						this.dc4.form.pd0codigo = pd0.pd0codigo
					}
					if (this.changePassword) {
						this.$router.push({ name: "changePassword" })
					}
				}
			}
			else if(this.dc4.companies.length > 0){
				this.selectCompany(this.dc4.companies[0])
			}
			this.changeSelectedUser()
		},
	}
</script>

<style scoped>
	#password >>> input {
		-webkit-text-security: circle !important;
	}
</style>
